export function debounce(fn, time: number): () => void {
	let timeout;
	return () => {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return, prefer-rest-params, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
		const functionCall = () => fn.apply(this, arguments);
		// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
		clearTimeout(timeout);
		timeout = setTimeout(functionCall, time);
	};
}

export function throttle(callback, limit: number): (arg?: unknown) => void {
	let wait = false;
	return (arg) => {
		if (!wait) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-call
			callback(arg);
			wait = true;
			setTimeout(() => {
				wait = false;
			}, limit);
		}
	};
}

export function memoizeValue(initValue: number | string): (value: number | string) => boolean {
	let prevValue = initValue;
	return (value: number | string) => {
		const isChanged = value !== prevValue;
		prevValue = value;
		return isChanged;
	};
}
